import React, { useState } from 'react';
import type { Recommendation } from '../types/bridgeIntelligence';
import { RecommendationCard } from './RecommendationCard';

interface BridgeRecommendationsProps {
  recommendations: Recommendation[];
  journey_id: string;
}

export const BridgeRecommendations: React.FC<BridgeRecommendationsProps> = ({
  recommendations,
  journey_id,
}) => {
  const [showAll, setShowAll] = useState(false);

  const displayedRecs = showAll ? recommendations : recommendations.slice(0, 3);

  return (
    <div className="bridge-recommendations">
      <div className="recommendations-header">
        <h3>💡 Smart Recommendations ({recommendations.length})</h3>
        {recommendations.length > 3 && (
          <button
            className="view-all-btn"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? 'Show Less' : 'View All'}
          </button>
        )}
      </div>

      <div className="recommendations-list">
        {displayedRecs.map((rec) => (
          <RecommendationCard
            key={rec.id}
            recommendation={rec}
            journey_id={journey_id}
            allRecommendations={recommendations}
          />
        ))}
      </div>

      {!showAll && recommendations.length > 3 && (
        <button className="show-more-btn" onClick={() => setShowAll(true)}>
          Show {recommendations.length - 3} more recommendations
        </button>
      )}
    </div>
  );
};
